import * as React from 'react';
import DialogBase from '../Shared/DialogBase';
import { Box, Button, TextField } from '@mui/material';
import { useApi } from '../Api/useApi';
import { ResetPasswordAdminRequest, UsersRycApiClient } from '../Api/ApiServer';

export interface IAdminResetPasswordProps {
    open: boolean;
    onClose: () => void;
    userId: number | null;
}

export default function AdminResetPassword(props: Readonly<IAdminResetPasswordProps>) {
    const { open, onClose, userId } = props;
    const [password, setPassword] = React.useState('');
    const { authorizedApi } = useApi(UsersRycApiClient);
    const resetPasswordByAdminAndGetNew = React.useCallback(async () => {
        if (!userId) return;
        const newPassword = await authorizedApi?.resetPasswordAdmin(new ResetPasswordAdminRequest({ id: userId }));
        setPassword(newPassword?.newPassword ?? '');
    }, [authorizedApi, userId]);
    React.useEffect(() => {
        if (open) {
            resetPasswordByAdminAndGetNew();
        }
    }, [open, resetPasswordByAdminAndGetNew]);
    return (
        <DialogBase showCloseButton title='Nové heslo'
            dialogActions={<Box m={1} justifyContent='center' display={'flex'} width='100%'>
                <Button variant='contained' onClick={onClose}>Zavřít</Button>
            </Box>}
            open={open} onClose={onClose}>
            <TextField sx={{ m: 2 }} value={password} label='Nové heslo' />
        </DialogBase>
    );
}
